"use client"

type ProductPreviewQtyModalProps = {
  open: boolean
  quantity: number
  onDecrease: () => void
  onIncrease: () => void
  onConfirm: () => void
  onClose: () => void
  isAdding?: boolean
  title?: string
  confirmLabel?: string
  cancelLabel?: string
  variants?: {
    id: string
    title: string
  }[]
  selectedVariantId?: string
  onSelectVariant?: (variantId: string) => void
  variantLabel?: string
}

export default function ProductPreviewQtyModal({
  open,
  quantity,
  onDecrease,
  onIncrease,
  onConfirm,
  onClose,
  isAdding = false,
  title = "",
  confirmLabel = "Add to cart",
  cancelLabel = "Cancel",
  variants = [],
  selectedVariantId,
  onSelectVariant,
  variantLabel = "Choose option",
}: ProductPreviewQtyModalProps) {
  if (!open) return null

  const showVariants = variants.length > 1
  const modalTitle = showVariants ? "Choose option" : "Choose quantity"

  return (
    <div className="fixed inset-0 z-[220] flex items-center justify-center bg-black/55 px-4">
      <div className="w-full max-w-[340px] rounded-3xl bg-white p-5 shadow-2xl">
        <div className="text-center text-lg font-extrabold text-black">
          {modalTitle}
        </div>

        {showVariants && (
          <div className="mt-5">
            <div className="mb-2 text-center text-sm font-bold text-black/70">
              


            </div>

            <div className="flex flex-wrap justify-center gap-2">
              {variants.map((variant) => {
                const active = variant.id === selectedVariantId

                return (
                  <button
                    key={variant.id}
                    type="button"
                    onClick={() => onSelectVariant?.(variant.id)}
                    disabled={isAdding}
                    className={`
                      rounded-2xl px-4 py-2 text-sm font-bold transition
                      ${
                        active
                          ? "bg-black text-white"
                          : "bg-neutral-200 text-black hover:bg-neutral-300"
                      }
                    `}
                  >
                    {variant.title}
                  </button>
                )
              })}
            </div>
          </div>
        )}

        {showVariants && (
  <div className="mt-5 text-center text-lg font-extrabold text-black">
    Quantity
  </div>
)}
        <div className="mt-5 flex items-center justify-center gap-4">
          <button
            type="button"
            onClick={onDecrease}
            disabled={isAdding || quantity <= 1}
            className="
              flex h-11 w-11 items-center justify-center rounded-2xl
              bg-neutral-200 text-xl font-extrabold text-black
              transition hover:bg-neutral-300
              disabled:cursor-not-allowed disabled:opacity-40
            "
          >
            −
          </button>

          <div
            className="
              flex min-w-[72px] items-center justify-center rounded-2xl
              border border-black/10 bg-neutral-50 px-4 py-3
              text-xl font-extrabold text-black
            "
          >
            {quantity}
          </div>

          <button
            type="button"
            onClick={onIncrease}
            disabled={isAdding}
            className="
              flex h-11 w-11 items-center justify-center rounded-2xl
              bg-neutral-200 text-xl font-extrabold text-black
              transition hover:bg-neutral-300
              disabled:cursor-not-allowed disabled:opacity-40
            "
          >
            +
          </button>
        </div>

        <div className="mt-5 flex flex-col gap-2">
          {/*
            data-tap-sound="addToCart"
            Финальная кнопка подтверждения добавления товара в корзину.
            Здесь нужен отдельный позитивный звук, потому что именно эта кнопка
            реально запускает добавление товара, а не просто открывает модалку.
          */}
          <button
            type="button"
            data-tap-sound="addToCart"
            onClick={onConfirm}
            disabled={isAdding}
            className="
              rounded-2xl bg-green-700 px-4 py-3
              text-sm font-extrabold uppercase tracking-wide text-white
              transition hover:brightness-110
              disabled:cursor-not-allowed disabled:opacity-60
            "
          >
            {isAdding ? "Adding..." : confirmLabel}
          </button>

          <button
            type="button"
            onClick={onClose}
            disabled={isAdding}
            className="
              rounded-2xl bg-neutral-200 px-4 py-3
              text-sm font-bold text-black
              transition hover:bg-neutral-300
              disabled:cursor-not-allowed disabled:opacity-60
            "
          >
            {cancelLabel}
          </button>
        </div>
      </div>
    </div>
  )
}